(ns ycweb.app.pos.stockadjust.stockadjust
  (:require
   [clojure.set :as set]
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.pos.menu :as menu]
   [ycweb.components.cards :as cards]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.header :as header]
   [ycweb.components.slats :as slats]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.components.wrapper :as w]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]))

(def steps
  (forms/setup-steps
    [{:key :start :title "Get Started"}
     {:key :products :title "Scan Products"}
     {:key :printer-scan :title "Scan Printer"}
     {:key :confirm :title "Confirm"}
     {:key :done :title "Done"}]))

(rum/defc stock-screen-wrapper
  [app-atom progress-step body foot-note call-to-action]
  (let [menu-atom (rum/cursor app-atom :menu)]
    [:div.page-body
     (header/header app-atom "Shrink & Grow" {})
     (header/menu-overlay menu-atom)
     (header/menu app-atom (menu/select-menus app-atom))

     (into
       [:div.page-body__main-content
        [:div.section
         (forms/progress-steps
           (forms/progress-step steps progress-step))]]
       body)

     (into
       [:aside.page-body__footer]
       foot-note)
     call-to-action]))

(rum/defc stock-screen < rum/reactive
  [app-atom]
  (stock-screen-wrapper app-atom :start
    [[:nav
      {:class (u/bem :section [:medium])}
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "What would you like to do?"]
      [:a.card.tile.u-angled-background.u-bg-red-dark.u-min-height-160
       {:style {:height "auto"}
        :on-click
        #(grid/dispatch-action app-atom :stock/start-stock-adjustment {:type :shrink})}
       [:span.tile__content
        [:span.tile__icon-wrapper
         [:i.tile__icon
          {:class (u/bem :icon [:2-2 :download :large :block])}]]
        [:span.tile__text "Shrink Items"]]]
      [:a.card.or-card.tile.u-angled-background.u-bg-mint-green-dark.u-min-height-160
       {:style {:height "auto"}
        :on-click
        #(grid/dispatch-action app-atom :stock/start-stock-adjustment {:type :grow})}
       [:span.tile__content
        [:span.tile__icon-wrapper
         [:i.tile__icon
          {:class (u/bem :icon [:2-2 :upload :large :block])}]]
        [:span.tile__text "Grow Items"]]]]]

    []
    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom)})))

(defmethod grid/action :stock/start-stock-adjustment [app-atom {:keys [type]} _]
  (swap! app-atom assoc-in [:manage-stock] {:type type})
  (t/transition-next app-atom :stock/products))

(defmethod flow/render-screen :stock [app-atom screen]
  (stock-screen app-atom))

(defn contains-many? [m & ks]
  (every? #(contains? m %) ks))

(defn is-item-completed [type item]
  (let [item (u/remove-blanks item)]
    (cond
      (= type :shrink)
      (contains-many? item :stock-item-qty :stock-item-reason :stock-item-summary)

      (= type :grow)
      (contains-many? item :stock-item-qty :stock-item-reason :stock-item-summary))))

(rum/defc stock-item-modal-body < rum/reactive [app-atom config-atom]
  (let [store-name (cmn/curact app-atom [:selected-warehouse :displayname])
        item-atom (rum/cursor config-atom :item)

        packsize
        (when (> (u/parseInt (cmn/curact item-atom [:display_packsize])) 1)
          (str (cmn/curact item-atom [:packdescription]) " of " (cmn/curact item-atom [:display_packsize])))

        shrink-type (cmn/curact config-atom :type)
        reason-code-limits (cmn/curact config-atom :reason-codes)

        adjustment-reasons
        (->>
          (cmn/curact config-atom :reasons)
          (map #(update % :effect (fn [e] (-> (str/lower-case e) keyword))))
          (filter #(if reason-code-limits (contains? reason-code-limits (:code %)) true)))]
    [:div
     [:div.modal__product-image
      [:img
       {:class (u/bem :image [:full])
        :src (u/cloudinary (:public_id (cmn/curact item-atom [:image])) {:c "lpad"}) :alt ""}]]

     (cards/product-infoblock (cmn/curval item-atom) true)

     (when packsize
       (feedback/feedback :warning
         (str "Note: This item is sold as a " packsize ".")
         (str "Be careful when " (u/safe-name shrink-type) "ing.")
         nil :stock))
     [:div.u-hr]

     [:div
      [:h3 {:class (u/bem :heading [:standard])} (str/capitalize (u/safe-name shrink-type)) "ing " (if (= shrink-type :shrink) "from: " "to: ")
       store-name " Store"]

      (forms/input (str "Qty to " (u/safe-name shrink-type) ":") "" (rum/cursor item-atom :stock-item-qty) {:type :text-number :small-width true})

      (forms/select (str "Reason for " (u/safe-name shrink-type) "ing:")
        (rum/cursor item-atom :stock-item-reason)
        (into
          [{:value "" :text "- Please Select -"}]
          (->>
            adjustment-reasons
            (filter #(= shrink-type (:effect %)))
            (map #(update % :label (fn [text] (str (:code %) ": " text))))
            (map #(select-keys % [:id :label]))
            (map #(set/rename-keys % {:label :text :id :value})))))

      (forms/textarea "Summary of what went wrong:"
        (rum/cursor item-atom :stock-item-summary))]]))

(rum/defc stock-item-modal-footer < rum/reactive [app-atom config-atom]
  (let [type (cmn/curact config-atom :type)]
    (grid/button-row
      {:left-text "Cancel"
       :left-fn #(grid/dispatch-modal-action app-atom :stock/stock-item-modal-cancel)
       :left-no-icon true
       :right-text "Save"
       :right-fn
       (when
         (is-item-completed type (cmn/curact config-atom :item))
         #(grid/dispatch-modal-action app-atom (:save-key @config-atom)))
       :right-no-icon true})))

;; Shrink & Grow
(defmethod grid/action :stock/add-shrink-item [app-atom config]
  (swap! app-atom update-in [:manage-stock :cart :items]
    (fn [items] (-> config :item (cons items) vec))))

(defmethod grid/modal-config :stock/stock-item-modal [_ _ _]
  {:body stock-item-modal-body
   :footer stock-item-modal-footer})

(defmethod grid/action :stock/update-shrink-item [app-atom {:keys [item idx]} _]
  (swap! app-atom update-in [:manage-stock :cart :items idx] merge item))

(defn open-stock-item-modal [app-atom type save-key config]
  (grid/open-modal app-atom :stock/stock-item-modal (merge config {:type type :save-key save-key})))

(defmethod comms/receive :pos/stock-add-item [app-atom e]
  ;; TODO: Borken paradigm (open + close should be together)
  (toaster/close-subtle-progress app-atom)
  (grid/close-modal app-atom)
  (when (:warn e)
    (toaster/open-toast app-atom :warning (:warn e) {}))

  (swap! app-atom assoc-in [:manage-stock :reasons] (:reasons e))
  (open-stock-item-modal
    app-atom (get-in @app-atom [:manage-stock :type]) :stock/add-shrink-item
    {:item (:item e)
     :reasons (:reasons e)}))

(defmethod grid/action :stock/printer-scan [app-atom {:keys [scan]} _]
  (swap! app-atom assoc-in [:manage-stock :printer] scan)
  (t/transition-next app-atom :stock/summary))

(defmethod flow/barcode-dispatch-screen :stock/printer-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :stock/printer-scan {:scan scan}))

(rum/defc printer-scan < rum/reactive [app-atom]
  (w/wrapper app-atom "Shrink & Grow" {:steps steps :step :printer-scan}
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan Printer"]
      grid/barcode-icon]]
    [[:aside.page-body__footer
      [:p.u-text-center
       {:class (u/bem :paragraph [:flush])}
       "Scan printer to continue"]]]
    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom)
       :right-fn nil
       :right-text "Scan Printer"
       :right-plain true})))

(defmethod flow/render-screen :stock/printer-scan [app-atom screen]
  (printer-scan app-atom))

(rum/defc stock-products < rum/reactive [app-atom]
  (let [stock-atom (rum/cursor-in app-atom [:manage-stock])
        stock-type (cmn/curact stock-atom :type)
        items (cmn/curact stock-atom [:cart :items])
        reasons (cmn/curact stock-atom [:reasons])
        visual-merchandising (first (filter #(= "VM" (:code %)) reasons))
        reason-groups (group-by :stock-item-reason items)
        vm-only?
        (and
          (= (count reason-groups) 1)
          (= (first (keys reason-groups)) (str (:id visual-merchandising))))]

    (stock-screen-wrapper app-atom :products
      [(if items
         [:div.slats
          {:class [(str "slats--items-to-" (u/safe-name stock-type))]}
          [:h3.slat.heading-slat
           [:span.heading-slat__icon-wrapper [:i {:class (u/bem :icon [:block (if (= :shrink stock-type) :download :upload)])}]]
           [:span.heading-slat__text "Items to " (u/safe-name stock-type) ":"]]

          (map-indexed
            (fn [idx i]
              (slats/item-stock-slat stock-type i
                {:type stock-type
                 :options-fn #(open-stock-item-modal app-atom stock-type :stock/update-shrink-item {:item i :idx idx})}))
            items)]

         [:div.section.u-margin-top-24
          [:h2.u-text-center
           {:class (u/bem :heading [:standard])}
           "Scan or Search Items to " (str/capitalize (u/safe-name stock-type))]
          [:div
           [:i.u-block-center
            {:class
             (u/bem
               :icon
               [:2-1 :barcode-scan :light-force :enormous :block])}]]])]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn
         (cond
           (empty? items)
           nil

           vm-only?
           #(t/transition-next app-atom :stock/summary)

           (= :shrink stock-type)
           #(t/transition-next app-atom :stock/printer-scan)

           :else
           #(t/transition-next app-atom :stock/summary))}))))

(defmethod flow/render-screen :stock/products [app-atom screen]
  (stock-products app-atom))

(defmethod flow/barcode-dispatch-screen :stock/products [_ app-atom scan]
  (grid/dispatch-action app-atom :stock/item-scan {:scan scan}))

(defmethod grid/action :stock/item-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :pos/stock-barcodescan
    {:session-uuid (:session-uuid @app-atom)
     :barcode scan}))

(rum/defc stock-summary < rum/reactive
  [app-atom]
  (let [stock-atom (rum/cursor-in app-atom [:manage-stock])
        stock-type (cmn/curact stock-atom :type)

        items (cmn/curact stock-atom [:cart :items])
        items-count (reduce + (map (fn [i] (u/parseInt (:stock-item-qty i))) items))
        next-enabled (boolean (cmn/curact stock-atom [:checked-list]))
        authorized? (boolean (cmn/curact stock-atom [:authorized?]))]

    (stock-screen-wrapper app-atom :confirm
      [[:div.section
        [:h2.u-text-center {:class (u/bem :heading [:standard])}
         "Confirm items to " (u/safe-name stock-type)]
        [:ul {:class (u/bem :order-calc [:fulfillment])}
         [:li.order-calc__item
          [:span.order-calc__item-icon-wrapper [:i {:class (u/bem :icon [:block (if (= :shrink stock-type) :download :upload)])}]]
          [:span.order-calc__item-name "Items to " (u/safe-name stock-type)]
          [:span.order-calc__item-value [:b items-count]]]]]

       [:div.slats
        {:class [(str "slats--items-to-" (u/safe-name stock-type))]}
        (map-indexed
          (fn [idx i]
            (slats/item-stock-summary-slat stock-type i
              {:type stock-type
               :options-fn #(open-stock-item-modal app-atom stock-type :stock/update-shrink-item {:item i :idx idx})}))
          items)]

       (when authorized?
         [:div.section.section--medium.u-margin-bottom-24
          (feedback/action-feedback
            (if (= :shrink stock-type) :download :upload)
            "Checked" (str " the " (u/safe-name stock-type) " list?")
            (rum/cursor-in stock-atom [:checked-list])
            {})])]

      (when-not authorized?
        [[:p.paragraph.paragraph--flush.u-text-center
          [:i. {:class (u/bem :icon [:inline :in-copy-left :barcode-scan :2-1])}]
          "To " (u/safe-name stock-type) " stock, scan manager's tag"]])

      (when items
        (grid/pos-call-to-action
          {:left-fn
           (fn []
             ; invalidate scan and checkbox
             (swap! stock-atom dissoc :checked-list)
             (grid/dispatch-action app-atom :stock/summary-back {}))
           :right-fn
           (when next-enabled
             #(grid/dispatch-action app-atom :stock/capture-stock-movement app-atom))
           :right-text (cond (= (u/safe-name stock-type) "grow") "Grow" :else "Shrink")
           :right-no-icon true})))))

(defmethod flow/render-screen :stock/summary [app-atom screen]
  (stock-summary app-atom))

(defmethod flow/barcode-dispatch-screen :stock/summary [_ app-atom scan]
  (grid/dispatch-action app-atom :stock/adjustment-manager-scan {:scan scan}))

(defmethod grid/action :stock/adjustment-manager-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :pos/request-permission-for-stock-movement
    {:session-uuid (:session-uuid @app-atom)
     :scan scan}))

(defmethod comms/receive :pos/request-permission-for-stock-movement [app-atom {:keys [authorized?] :as e}]
  (toaster/close-subtle-progress app-atom)
  (cond
    authorized?
    (swap! app-atom assoc-in [:manage-stock :authorized?] authorized?)

    :else
    (toaster/open-toast app-atom :warning (:message e) {})))

(defmethod grid/action :stock/summary-back
  [app-atom & _]
  (swap! app-atom update :manage-stock dissoc :authorized?)
  (t/transition-prev app-atom))

(defmethod grid/action :stock/capture-stock-movement [app-atom config _]
  (let [{:keys [printer cart type]} (get-in @app-atom [:manage-stock])]
    (comms/send :pos/capture-stock-movement
      {:session-uuid (:session-uuid @app-atom)
       :items (:items cart)
       :printer printer
       :type type})
    (toaster/open-toast app-atom :processing (str "Processing " (str/capitalize (u/safe-name type))) {})))

(defmethod comms/receive :pos/stock-move-complete [app-atom e]
  (let [type (get-in @app-atom [:manage-stock :type])]
    (toaster/open-toast app-atom :success (str (str/capitalize (u/safe-name type)) " completed.") {})
    (t/transition-next app-atom :stock/done)))

(rum/defc stock-done < rum/reactive
  [app-atom]
  (let [stock-atom (rum/cursor-in app-atom [:manage-stock])]
    (stock-screen-wrapper app-atom :done
      [[:div
        [:div.u-margin-top-24
         [:div
          {:class (u/bem :section [:medium])}
          [:h2.u-text-center
           {:class (u/bem :heading [:large])}
           [:b "Done"]]
          [:i.u-block-center
           {:class (u/bem :icon [:3-3 :success :enormous :block])}]
          [:div.u-margin-top-24
           [:p.u-text-center
            {:class (u/bem :paragraph [:large])}
            [:b (str/capitalize (u/safe-name (cmn/curact stock-atom :type))) " complete."]]]]]]]

      []

      [:div.call-ato-action
       (grid/pos-call-to-action
         {:single-fn #(t/transition-next app-atom :stock)})])))

(defmethod flow/render-screen :stock/done [app-atom screen]
  (stock-done app-atom))